(function () {
	function defaultTo(value, fallback) {
		return value == null || value !== value ? fallback : value;
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		if (number == null || Number.isNaN(number)) {
			return "0";
		}

		var cents = (number / 100).toFixed(defaultTo(precision, 2));
		var parts = cents.split(".");
		var dollars = parts[0].replace(
			/\B(?=(\d{3})+(?!\d))/g,
			defaultTo(thousands, ",")
		);
		var centsPart = parts[1] ? defaultTo(decimal, ".") + parts[1] : "";

		return dollars + centsPart;
	}

	function formatMoney(cents, format) {
		var value = typeof cents === "string" ? cents.replace(".", "") : cents;
		var template = defaultTo(format, "${{amount}}");
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var placeholderMatch = template.match(placeholderRegex);

		if (!placeholderMatch) {
			return template;
		}

		var placeholder = placeholderMatch[1];
		var formattedValue = "0";

		switch (placeholder) {
			case "amount":
				formattedValue = formatWithDelimiters(value, 2);
				break;
			case "amount_no_decimals":
				formattedValue = formatWithDelimiters(value, 0);
				break;
			case "amount_with_comma_separator":
				formattedValue = formatWithDelimiters(value, 2, ".", ",");
				break;
			case "amount_no_decimals_with_comma_separator":
				formattedValue = formatWithDelimiters(value, 0, ".", ",");
				break;
			case "amount_no_decimals_with_space_separator":
				formattedValue = formatWithDelimiters(value, 0, " ");
				break;
			case "amount_with_apostrophe_separator":
				formattedValue = formatWithDelimiters(value, 2, "'");
				break;
			default:
				formattedValue = formatWithDelimiters(value, 2);
				break;
		}

		return template.replace(placeholderRegex, formattedValue);
	}

	window.Shopify = window.Shopify || {};
	window.Shopify.formatMoney = formatMoney;
})();
